import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Button, Form, Grid, Header, Segment, Message, Image } from 'semantic-ui-react';
import i18next from 'i18next';

import api from '../../actions/api';
import logoIcon from '../../assets/images/logo.png';

import './PasswordRecovery.scss';

class PasswordRecovery extends Component {
    state = { email: '', success: false, error: undefined };

    handleSubmit = (event) => {
        event.preventDefault();

        const { email } = this.state;

        if (!email) {
            this.setState({ error: 'emailNotProvided', success: false });
            return;
        }

        const emailValidationRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if (!emailValidationRegex.test(email)) {
            this.setState({ error: 'emailFormatIssue', success: false });
            return;
        }

        api.auth.password.sendRecoveryEmail({ email }).then(({ data }) => {
            this.setState({ error: undefined, success: true });
        }).catch(error => {
            this.setState({ error: error.response.data, success: false });
        });
    }

    render() {
        const { token } = this.props;

        if (token) {
            return <Redirect to={{ pathname: '/' }} />;
        }

        return (
            <Grid textAlign='center' verticalAlign='middle' className='pi-password-recovery'>
                <Grid.Row verticalAlign='middle'>
                    <Grid.Column className='pi-password-recovery-main-column'>
                        <Image src={logoIcon} size="tiny" centered className='pi-paidit-logo' />
                        <Header as='h2' textAlign='center' className='pi-password-recovery-header'>
                            {i18next.t('passwordRecovery.self')}
                        </Header>
                        <Form
                            size='large'
                            success={this.state.success}
                            error={!!this.state.error}
                            onSubmit={this.handleSubmit}
                        >
                            <Segment stacked>
                                <Form.Input
                                    fluid
                                    icon='at'
                                    iconPosition='left'
                                    placeholder={i18next.t('email')}
                                    value={this.state.email}
                                    onChange={({ target }) => this.setState({ email: target.value })}
                                    required
                                />

                                <Message error
                                    header={i18next.t('passwordRecovery.emailErrors.failedTitle')}
                                    content={i18next.t(`passwordRecovery.emailErrors.${this.state.error}`)} />
                                <Message success
                                    header={i18next.t('passwordRecovery.successTitle')}
                                    content={i18next.t(`passwordRecovery.goToEmail`)} />
                                <Button color='blue' fluid size='large' className='pi-password-recovery-button'>
                                    {i18next.t('passwordRecovery.sendEmail')}
                                </Button>
                            </Segment>
                            <a href='/login' className='pi-back-to-login'>{i18next.t('passwordRecovery.backToLogin')}</a>
                        </Form>
                    </Grid.Column>
                </Grid.Row>
            </Grid >
        );
    }
}

PasswordRecovery.propTypes = {
    token: PropTypes.string,
    
};

const mapStateToProps = (state) => {
    const { token } = state.auth;

    return { token };
};

export default connect(mapStateToProps)(PasswordRecovery);
